// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";

jQuery(function ($) {

  // Call the pretty Foundation scripts
  $(document).foundation();

  // Give the full page slide dynamic height
  $('.full-page-slide').css('height', $(window).height());

  // Allow for smooth scrolling
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
      var target = $(this.hash);
      var targetID = target[0].id;
      if (targetID !=  "main-content") {
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        // if (target.href != location.pathname+"/#main-content") {
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
      // }
    }
  });

  $(".link-box").click(function(){
   if($(this).find("a").length){
       window.location.href = $(this).find("a:first").attr("href");
   }
  });

});
